import { Button } from "@fluentui/react-components";
import {
  ThumbDislike16Filled,
  ThumbDislike16Regular,
  ThumbLike16Filled,
  ThumbLike16Regular,
} from "@fluentui/react-icons";
import { useState } from "react";
import { FeedbackModal } from "../feebackModal/FeedbackModal";
import { IThumbsFeedbackProps } from "./ThumbsFeedback.types";

export const styles = {
  feedbackContainer: {
    display: "flex",
    alignItems: "center",
  },
  hovered: {
    transform: "scale(1.1)",
    transition: "transform 0.2s ease-in-out",
  },
};

export const ThumbsFeedback = (props: IThumbsFeedbackProps) => {
  const [feedback, setFeedback] = useState<"like" | "dislike" | null>(null);
  const [hovered, setHovered] = useState<"like" | "dislike" | null>(null);

  const handleFeedback = (type: "like" | "dislike" | null) => {
    const newFeedback = feedback === type ? null : type;
    setFeedback(newFeedback);
  };

  return (
    <div style={styles.feedbackContainer}>
      <Button
        appearance={"subtle"}
        icon={
          hovered === "like" ? (
            <ThumbLike16Filled color="black" />
          ) : (
            <ThumbLike16Regular />
          )
        }
        onClick={() => handleFeedback("like")}
        onMouseEnter={() => setHovered("like")}
        onMouseLeave={() => setHovered(null)}
      />
      <Button
        appearance={"subtle"}
        icon={
          hovered === "dislike" ? (
            <ThumbDislike16Filled color="black" />
          ) : (
            <ThumbDislike16Regular />
          )
        }
        onClick={() => handleFeedback("dislike")}
        onMouseEnter={() => setHovered("dislike")}
        onMouseLeave={() => setHovered(null)}
      />
      {feedback && (
        <FeedbackModal
          isOpen={!!feedback}
          onClose={() => setFeedback(null)}
          feedbackType={feedback}
          message={props.message}
          previousMessage={props.previousMessage}
          onSubmit={(data) => () => {}}
        />
      )}
    </div>
  );
};
